import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let UserPermissionModelImpl = class UserPermissionModelImpl {
    constructor() {
        this._userPermission = proxy(null);
    }
    get userPermission() {
        return this._userPermission.value;
    }
    updateUserPermission(userPermission) {
        this._userPermission.value = {
            ...this.userPermission,
            ...userPermission,
        };
    }
    subscribeUserPermission(callback) {
        const dispose = subscribe(() => this._userPermission.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
UserPermissionModelImpl = __decorate([
    injectable()
], UserPermissionModelImpl);
export { UserPermissionModelImpl };
